import * as React from "react";

import {IApplicationStoreState, applicationStore} from '../stores/ApplicationStore'

export interface ICommunicationNavigationProps {
    activeData?: IActionData,
    onItemClick: (data: IActionData) => void
}

export default class CommunicationNavigation extends React.Component<ICommunicationNavigationProps, IApplicationStoreState> {

    constructor() {
        super();
        
        this.state = applicationStore.getState();
        
        this.onChange = this.onChange.bind(this);
    }
    
    componentDidMount() {
        applicationStore.addChangeListener(this.onChange);
    }

    componentWillUnmount() {
        applicationStore.removeChangeListener(this.onChange);
    }

    onChange() {
        this.setState(applicationStore.getState());
    }
    
    handleItemClick(data: IActionData) {
        this.props.onItemClick(data);
    }
	
    render() {
        var data = this.state.communicationData || [];
        
        return (
            <ul className="nav nav-pills nav-stacked">
                {
                    data.sort(function (l, r) {
                        var lDateTime = Date.parse(l.DateTime);
                        var rDateTime = Date.parse(r.DateTime);

                        if (lDateTime < rDateTime)
                            return 1;
                        if (lDateTime > rDateTime)
                            return -1;
                        return l.Guid < r.Guid ? 1 : (l.Guid > r.Guid ? -1 : 0);
                    })
                    .map(function (d, index) {
                        var c = this.props.activeData && d.Guid === this.props.activeData.Guid ? 'active' : ''; 
                        var uriText: string = d.RequestUri.replace('http://', '');
                        
					    return <li key={d.Guid} className={c}>
                            <a onClick={this.handleItemClick.bind(this, d)}>
                            {`${d.DateTime} - ${uriText}`}
                            </a>
                        </li>;
                    }, this)
                }
			</ul>
		);
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/CommunicationNavigation.tsx